import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 逾期查验列表缓存有效期（毫秒）：避免每次路由跳转都请求后端
const OVERDUE_CACHE_TTL = 30 * 1000

// 进行中的请求（in-flight）：多个调用方并发触发时共用同一个请求，避免重复调接口
let overdueFetchingPromise = null

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: null,
    // 逾期未填报查验信息的订单列表（供货商端专用）
    overdueInspections: [],
    overdueLoaded: false,
    overdueFetchedAt: 0,
    // 全局逾期弹窗显隐
    overdueDialogVisible: false
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_OVERDUE_INSPECTIONS(state, list) {
      state.overdueInspections = Array.isArray(list) ? list : []
      state.overdueLoaded = true
      state.overdueFetchedAt = Date.now()
    },
    CLEAR_OVERDUE_INSPECTIONS(state) {
      state.overdueInspections = []
      state.overdueLoaded = false
      state.overdueFetchedAt = 0
      state.overdueDialogVisible = false
    },
    SET_OVERDUE_DIALOG_VISIBLE(state, visible) {
      state.overdueDialogVisible = visible
    }
  },
  actions: {
    login({ commit }, data) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', data.token)
        commit('SET_USER_INFO', data.userInfo)
        resolve()
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        commit('CLEAR_OVERDUE_INSPECTIONS')
        resolve()
      })
    },
    /**
     * 拉取逾期未填报查验信息的订单列表
     * @param {Boolean} force 是否强制刷新（填报提交成功后使用）
     */
    fetchOverdueInspections({ commit, state }, force) {
      if (!force && state.overdueLoaded && (Date.now() - state.overdueFetchedAt) < OVERDUE_CACHE_TTL) {
        return Promise.resolve(state.overdueInspections)
      }
      // 已有请求进行中：直接复用，避免并发重复调用
      if (overdueFetchingPromise) return overdueFetchingPromise
      // 动态引入 api，打破 store → api → request → router → store 的静态循环依赖
      overdueFetchingPromise = import('@/api/orderInspection')
        .then(m => m.getOverdueList())
        .then(res => {
          const list = (res && res.data) || []
          commit('SET_OVERDUE_INSPECTIONS', list)
          return list
        })
        .catch(() => {
          commit('SET_OVERDUE_INSPECTIONS', [])
          return []
        })
        .finally(() => {
          overdueFetchingPromise = null
        })
      return overdueFetchingPromise
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo
  }
})
